export default __webpack_public_path__ + "static/media/hn.ebef2cd5.svg";